import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	selectAnyShift: {
		id: 'eoc-on-call.tours.shift-tile.select-any-shift',
		defaultMessage: 'Select any shift to view more',
		description: 'Title of shift tile spotlight.',
	},
	viewSummaryOfShift: {
		id: 'eoc-on-call.tours.shift-tile.view-summary-of-shift',
		defaultMessage:
			'View a summary of the shift and its participants. You can also add an override if necessary.',
		description: 'Description of shift tile spotlight.',
	},
});
